import { render, staticRenderFns } from "./widget-stat.vue?vue&type=template&id=6b651c7d&"
import script from "./widget-stat.vue?vue&type=script&lang=js&"
export * from "./widget-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b651c7d')) {
      api.createRecord('6b651c7d', component.options)
    } else {
      api.reload('6b651c7d', component.options)
    }
    module.hot.accept("./widget-stat.vue?vue&type=template&id=6b651c7d&", function () {
      api.rerender('6b651c7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/widget-stat.vue"
export default component.exports